export default {
    methods: {
        setPaymenttypesVoucher (paymenttypes) {
            this.paymenttypes_voucher = paymenttypes.filter(paymenttype => {
                return paymenttype.attributes.voucher_payment === true;
            });
        },
    }
}
